const state = {
    selectedAgtGroup:null,
    allAgentRes:null


};

const getters = {
    GET_SELECTED_AGENT_GROUP: (state) => {
        return state.selectedAgtGroup;
    },
    GET_ALL_AGENT_GROUP_RES: (state) => {
        return state.allAgentRes;
    },






};
const actions = {

    CLEAR_Agent_STORE: ({ commit }) => {
        commit('clearStore');
    },

    SET_SELECTED_AGENT_GROUP: ({ commit }, agent) => {
        commit('saveSelAgentGroup', agent);
    },
    SET_ALL_AGENT_GROUP_RES: ({ commit }, res) => {
        commit('saveAgentGroupRes', res);
    },
};

const mutations = {
    clearStore: (state) => {
        state.selectedAgtGroup = null;
        state.allAgentRes = null;
        
    },
    saveSelAgentGroup: (state, agent) => {
        state.selectedAgtGroup = agent;
    },
    saveAgentGroupRes: (state, res) => {
        state.allAgentRes = res;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};